<template>
  <div class="layer-options" v-show="isShow">
    <div class="layer-options__wrapper">
      <ul class="layer-options__list">
        <li
          class="layer-options__item"
          v-for="(item, i) in list"
          :key="i"
          @click="setLayerZIndex(item.alias)"
        >
          <i :class="['icon-editor-btn-layer-' + item.alias]"></i>
          <span>{{item.text}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isShow: false,
      list: [
        {text: '置顶', action: 'front', alias: 'top'},
        {text: '置底', action: 'back', alias: 'bottom'},
        {text: '上移一层', action: 'forward', alias: 'up'},
        {text: '下移一层', action: 'backward', alias: 'down'}
      ]
    }
  },
  computed: {
    ...mapGetters([
      'TOOL'
    ])
  },
  methods: {
    toggle (flag = true) {
      this.isShow = flag;
    },
    setLayerZIndex(flag) {
      let sprite = (this.TOOL.selectedSprite || [])[0];
      if (!sprite) {
        return;
      }
      switch (flag) {
        case 'top':
          this.TOOL.moveSpriteTo(sprite.id, (this.TOOL.selectedScenes.sprites || []).length - 1, true);
          this.$analysis({category:'editor_layer', action:'click_layer_top', label:'编辑器_图层_置顶'});
          break
        case 'bottom':
          this.TOOL.moveSpriteTo(sprite.id, 0, true);
          this.$analysis({category:'editor_layer', action:'click_layer_bottom', label:'编辑器_图层_置底'});
          break
        case 'up':
          this.TOOL.moveSpriteTo(sprite.id, sprite.index + 1, true);
          this.$analysis({category:'editor_layer', action:'click_layer_up', label:'编辑器_图层_上移'});
          break
        case 'down':
          this.TOOL.moveSpriteTo(sprite.id, sprite.index - 1, true);
          this.$analysis({category:'editor_layer', action:'click_layer_down', label:'编辑器_图层_下移'});
          break
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.layer-options {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &.active {

    height: auto;
    // top: 30px;


    > &__list {
      opacity: 1;
      top: 30px;
      height: auto;
    }
  }

  &__list {
    position: relative;
    background-color: #fff;
    width: 116px;
    padding: 3px;
    border-radius: 4px;
    box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);

    &:before {
      position: absolute;
      top: -18px;
      left: 0;
      right: 0;
      margin: 0 auto;
      content: '';
      width:0;
      height:0;
      border-width: 10px 8px;
      border-style: solid;
      border-color: rgba(0,0,0,0) rgba(0,0,0,0) #fff rgba(0,0,0,0);
    }
  }

  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    border-radius: 4px;
    color: #474261;
    margin-bottom: 3px;
    // background-color: #f0f0f8;

    &:last-child {
      margin-bottom: 0;
    }

    & > span {
      padding-left: 0.5em;
      width: 70px;
      white-space: nowrap;
    }

    &:hover {
      background-color: #D4D4E7;
    }
  }

  &__wrapper {
    position: absolute;
    left: 50%;
    transform: translatex(-50%);
    top: 50%;
    z-index: -1;
    transition: all 0.3s;
    opacity: 0;
    padding-top: 20px;
    height: 0;
    overflow: hidden;
  }
}
.layer-options:hover {
  .layer-options__wrapper {
    top: 30px;
    opacity: 1;
    height: auto;
    z-index: -1;
  }
  .layer-options__list {
    // opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/editorBtn/layerOptions.vue